import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

export const retrieve = ({ commit }, { id, type = 'basic' }) => {
  commit(types.SETTLEMENTREPORT_SHOW_TOGGLE_LOADING)

  return fetch(id + '?freq=' + type)
    .then((response) => response.json())
    .then((data) => {
      commit(types.SETTLEMENTREPORT_SHOW_TOGGLE_LOADING)
      commit(types.SETTLEMENTREPORT_SHOW_SET_RETRIEVED, { retrieved: data, type: type })
      return data
    })
    .catch((e) => {
      commit(types.SETTLEMENTREPORT_SHOW_TOGGLE_LOADING)
      commit(types.SETTLEMENTREPORT_SHOW_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.SETTLEMENTREPORT_SHOW_RESET)
}
